<template>
  <transition name="loading" appear>
    <div class="loading-wrapper">
      <div class="box-wrapper">
        <div class="box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p>加载中...</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped lang="scss">
@keyframes ScaleY {

  0%,
  40%,
  100% {
    transform: scaleY(0.2);
  }

  20% {
    transform: scaleY(1.0);
  }
}
.loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  left: 0rem;
  top: 0rem;
  z-index: 99;

  .box-wrapper {
    width:3.2rem;
    position: absolute;
    left: 50%;
    margin-left: -1.6rem;
    top: 46%;

    .box {
      height: 1rem;
      text-align: center;

      div {
        background-color: #fee01c;
        height: 100%;
        width: 0.08rem;
        display: inline-block;
        animation: ScaleY 1.2s infinite ease-in-out;

        &:nth-of-type(2) {
          animation-delay: -1.1s;
        }

        &:nth-of-type(3) {
          animation-delay: -1s;
        }

        &:nth-of-type(4) {
          animation-delay: -0.9s;
        }

        &:nth-of-type(5) {
          animation-delay: -0.8s;
        }
      }
    }

    p {
      font-size: 0.32rem;
      color: #fee01c;
      margin-top: 0.12rem;
      text-align: center;
      font-weight: normal;
    }
  }
}

.loading-enter-active {
  animation: Animate 1s linear;
}

.loading-leave-active {
  animation: Animate 0.6s linear reverse;
}

@keyframes Animate {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>